<template>
    <console-content max-width="1024px">
        <v-row align="end" class="mt-3">
            <v-col cols="auto" class="headline">핀 대량 폐기 (Excel)</v-col>
            <v-spacer/>
            <v-col cols="auto" class="py-0">
                <v-btn color="white" @click="downloadExample()" class="green--text px-2"><v-icon class="mr-2">{{ mdiMicrosoftExcel }}</v-icon>양식 다운로드</v-btn>
            </v-col>
        </v-row>

        <v-card class="mt-4">
            <v-card-title>
                <v-row align="center" justify="end" no-gutters>
                    <v-col cols="12" md="6">
                        <v-file-input accept=".xlsx" label="업로드 파일(.xlsx)" placeholder=" " @change="importExcel" hide-details
                                    :prepend-icon="mdiMicrosoftExcel" ></v-file-input>
                    </v-col>
                    <v-spacer/>
                    <v-col cols="auto">
                        <v-btn color="secondary" class="mr-4" :loading="loading" @click="check">
                            <v-icon left size="20">{{ mdiDatabaseSearch }}</v-icon>
                            <span>금액확인</span>
                        </v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn color="error" outlined class="mr-4" @click="cancel">
                            <v-icon left size="20">mdi-delete-outline</v-icon>
                            <span>폐기하기</span>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider/>

            <template v-if="checked && checkedSummary.length">
                <v-card-text>
                    <v-row no-gutters>
                        <v-col cols="auto" class="mx-auto">권종 / 개수</v-col>
                    </v-row>
                    <v-row v-for="({ faceamt, count }, index) in checkedSummary" :key="index" no-gutters>
                        <v-col cols="auto" class="mx-auto"><strong>{{ (+faceamt).format() }}</strong>원 / <strong>{{ (+count).format() }}</strong>개</v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="auto" class="mx-auto">총 금액 : <strong>{{ checkedSummary.reduce((total, { faceamt, count }) => total + faceamt * count, 0)?.format?.() }}</strong>원</v-col>
                    </v-row>
                </v-card-text>
                <v-divider/>
            </template>

            <v-card-text class="pa-0">
                <v-data-table :headers="pinHeaders" :items="pins" hide-default-footer disable-pagination disable-sortable></v-data-table>
            </v-card-text>
        </v-card>
    </console-content>
</template>
<script>
import api from "@/api";

import XLSX from "xlsx";
import download from "downloadjs";
import { mdiMicrosoftExcel, mdiDatabaseSearch } from "@mdi/js";
import ConsoleContent from "@/components/console/console-content.vue";

export default {
    components: {
        ConsoleContent
    },
    data(){
        return {
            mdiMicrosoftExcel,
            mdiDatabaseSearch,
            
            loading: false,
            checked: false,
            checkedPins: [],

            sheet: [],
            pinHeaders: [{
                text: "핀번호",
                align: "center",
                value: "pno"
            }],
        }
    },
    methods: {
        importExcel(file) {
            if(!file) return;

            let reader = new FileReader();
            reader.onload = (e) => {
                var workSheets = [];
                var workBook = XLSX.read(reader.result, { type: 'binary' });
                workBook.SheetNames.forEach(sheetName => {
                    let sheet = XLSX.utils.sheet_to_json(workBook.Sheets[sheetName]);
                    workSheets.push(sheet);
                });

                this.sheet = workSheets[0]; // 첫번째 시트
            };
            reader.readAsBinaryString(file);
        },
        downloadExample(){
            download('/excel/example_cancel.xlsx');
        },
        async check(){
            this.loading = true;

            if(this.pins?.length){
                let { pins } = await api.console.pins.gets({
                    params: {
                        pnos: this.pins.map(pin => pin.pno)
                    },
                    headers: {
                        limit: 0
                    }
                });
    
                this.checkedPins = pins;
                this.checked = true;
            }

            this.loading = false;
        },
        async cancel(){
            if(confirm("폐기하시겠습니까?")){
                await api.console.pins.cancel({ pins: this.pins });

                alert("폐기가 완료되었습니다");
            }
        }
    },
    computed: {
        pins(){
            var pins = [];
            for(var row of this.sheet){
                pins.push({ pno: row["핀번호"] });
            }
            return pins;
        },
        checkedSummary(){
            let summary = new Map();
            for(let pin of this.checkedPins){
                let faceamt = pin.faceamt;
                let count = summary.get(faceamt) || 0;

                summary.set(faceamt, count + 1);
            }

            return Array.from(summary, ([ faceamt, count ]) => ({ faceamt, count }));
        }
    }
}
</script>
